// extracted by mini-css-extract-plugin
module.exports = {"timerText1":"_2S1rq","wrapper":"_1aJ4W","timerWrapper":"_3iXto","timeLeftText":"Zfi9J","timer":"_2c-0H"};